"use client";
import dynamic from "next/dynamic";
import Image from "next/image";
const Player = dynamic(() => import("@mux/mux-player-react/lazy"), { ssr: false });

type MuxPlayerProps = {
  streamType?: "live" | "on-demand";
  playbackId?: string;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  className?: string;
  maxResolution?: "720p" | "1080p" | "1440p" | "2160p";
  thumbnailTime?: number;
  style?: React.CSSProperties;
  blurUrl?: string;
  hasPriority?: boolean;
  useGifThumbnail?: boolean; // New prop to toggle GIF thumbnail
  gestureControl?: boolean;
};

type ExtendedCSSProperties = React.CSSProperties & {
  [key: string]: string | number | undefined;
};

const MuxPlayer = ({
  playbackId,
  loop = true,
  muted = true,
  autoPlay = false,
  className,
  maxResolution,
  thumbnailTime,
  style = {},
  streamType = "on-demand",
  hasPriority = false,
  useGifThumbnail = false, // Default to static thumbnail
  gestureControl = false
}: MuxPlayerProps) => {
  const playerStyles: ExtendedCSSProperties = {
    ...style,
    height: "100%",
    "--bottomPlayButton": "none",
    "--media-control-bar": "none",
    "--rendition-selectmenu": "none",
    "--dialog": "none",
    "--loading-indicator": "none",
    "--media-control-display": gestureControl ? "block" : "none"
  };

  // Determine the thumbnail URL based on the useGifThumbnail prop
  const thumbnailUrl = useGifThumbnail
    ? `https://image.mux.com/${playbackId}/animated.gif`
    : `https://image.mux.com/${playbackId}/thumbnail.webp`;

  return (
    <div className={className}>
      <Player
        streamType={streamType}
        playbackId={playbackId}
        loop={loop}
        muted={muted}
        autoPlay={autoPlay}
        className={className}
        maxResolution={maxResolution}
        thumbnailTime={thumbnailTime}
        style={playerStyles}
        poster={thumbnailUrl}
        placeholder="data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAgABIDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFBAL/xAAeEAACAwACAwEAAAAAAAAAAAAAAQIDERIxBBQhUf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/EABkRAQEBAAMAAAAAAAAAAAAAAAABEQISIf/aAAwDAQACEQMRAD8AqWvGhmbWYfJvySNFd6dPZmcdbtLcfoC3etAvU1k8mEpNHUearwoyoTfR16y49CJUN89AseqvwB6P/9k="
      />
      {/* Added to prefetch the thumbnail image for videos with auto play */}
      {hasPriority ? <Image alt="" src={thumbnailUrl} className="display-none" fill priority /> : null}
    </div>
  );
};

export default MuxPlayer;
